module.exports = __webpack_public_path__ + "img/mars-stroke-right.5f3ed72d.svg";